
import React from 'react';
import { Input } from '@/components/ui/input';
import { ResellerPlanDetails } from '@/hooks/license/resellerPlans/types';

interface PlanPricingProps {
  plan: ResellerPlanDetails;
  onUpdatePlan: (field: keyof ResellerPlanDetails, value: any) => void;
}

const PlanPricing: React.FC<PlanPricingProps> = ({ plan, onUpdatePlan }) => {
  const handleNumberInput = (field: keyof ResellerPlanDetails, value: string) => {
    const numValue = parseFloat(value);
    console.log(`Updating ${String(field)} from ${plan[field]} to ${numValue}`);
    onUpdatePlan(field, isNaN(numValue) ? 0 : numValue);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium">Annual Price ($)</label>
        <Input 
          type="number" 
          value={plan.annualPrice?.toString() || '999'} 
          onChange={(e) => handleNumberInput('annualPrice', e.target.value)}
        />
      </div>
      
      <div>
        <label className="text-sm font-medium">Setup Fee ($)</label>
        <Input 
          type="number" 
          value={plan.setupFee?.toString() || '0'} 
          onChange={(e) => handleNumberInput('setupFee', e.target.value)}
        />
      </div>
      
      <div>
        <label className="text-sm font-medium">Plan Number (5-digit)</label>
        <Input 
          type="text" 
          value={plan.planNumber || ''}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, '').slice(0, 5);
            onUpdatePlan('planNumber', value);
          }}
          placeholder="12345"
          maxLength={5}
        />
      </div>
    </div>
  );
};

export default PlanPricing;
